import { all, call, put, takeLatest } from 'redux-saga/effects';
import { setBackOfficeData, setLoading } from '../slices/backOfficeSlice';
import { apiPostCall } from '../api';

const URL = process.env.REACT_APP_API_BASE;

function* setBackOfficeDataSaga(action: any) {
  try {
    yield call(apiPostCall, URL + `merge-back-office`, action.payload.data);
    yield put(setLoading());
    action.payload.setFormSubmitted(true);
  } catch (error: any) {
    console.error(error);
  }
}

export default function* backOfficeSaga() {
  yield all([takeLatest(setBackOfficeData.type, setBackOfficeDataSaga)]);
}
